import Component from '@cell/cell-core/component/component';
import './button.scss';

class Button extends Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.querySelector('.Button__Inner').on('click', this.handleClick);
  }

  handleClick() {
    this.emit('click', {
      action: this.parsedDataset.action,
    });
  }

  setLoading(isLoading) {
    this.classList.toggle('Button--Loading', isLoading);
  }

  disable() {
    this.querySelector('.Button__Inner').setAttribute('disabled', 'disabled');
  }

  enable() {
    this.querySelector('.Button__Inner').removeAttribute('disabled');
  }
}

customElements.define('c-button', Button);
